<template>
	<transition-group :name="transition" :style="{ '--total': items.length }">
		<div
			v-for="(item, index) in computedItems"
			:key="item"
			:style="{'--i': index}"
		>
			<slot :name="item">
				{{ item }}
			</slot>
		</div>
	</transition-group>
</template>

<script>
export default {
	props: {
		transition: {
			type: String,
			default: 'slide-fade'
		},
		items: {
			type: Array,
			default: () => ([])
		},
		show: Boolean
	},
	data() {
		return {
			slotItems: []
		};
	},
	computed: {
		computedItems() {
			if (!this.show) return [];
			return this.items.length > 0 ? this.items : this.slotItems;
		}
	},
	mounted() {
		this.slotItems = Object.keys(this.$slots);
	}
};
</script>

<style lang="scss">
.slide-fade {
	&-move {
		transition: opacity .4s linear, transform .4s ease-in-out;
	}
	
	&-leave-active {
		transition: opacity .3s linear, transform .3s cubic-bezier(.5,0,.7,.4); //cubic-bezier(.7,0,.7,1);
		transition-delay: calc( 0.08s * (var(--total) - var(--i)) );
	}
	
	&-enter-active {
		transition: opacity .4s linear, transform .4s cubic-bezier(.2,.5,.1,1);
		transition-delay: calc( 0.08s * var(--i) );
	}

	&-enter,
	&-leave-to {
		opacity: 0;
	}
	
	&-enter { transform: translateX(-1em); }
	&-leave-to { transform: translateX(1em); }
}
.fade {
	&-move {
		transition: opacity .4s linear;
	}
	
	&-leave-active {
		transition: opacity .3s linear; //cubic-bezier(.7,0,.7,1);
		transition-delay: calc( 0.05s * (var(--total) - var(--i)) );
	}
	
	&-enter-active {
		transition: opacity .4s linear;
		transition-delay: calc( 0.05s * var(--i) );
	}

	&-enter,
	&-leave-to {
		opacity: 0;
	}
}
</style>
<docs>
```jsx

new Vue({
	data(){
		return {
			show: true,
			items: [1,2,3,4,5,6]
		}
	},
	methods: {
		onChange(value) {
			this.show = value;
		}
	},
	template: `
	<div style="width:500px; height:150px;">
		<div style="padding: 10px 0px;">
			<t-switch label="Toggle" :checked="show" @change="onChange($event)"></t-switch>
		</div>
		<t-transition-group :show="show">
			<t-contact-info slot="1"  name="Hello" phone="1233456" company="Tim"/>
			<t-contact-info slot="2"  name="Hello2" phone="1233456" company="Tim"/>
			<t-contact-info slot="3"  name="Hello3" phone="1233456" company="Tim"/>
		</t-transition-group>
	</div>
	`
});
```
</docs>